import React from "react";
import {useNavigate} from "react-router-dom";
import {SidebarBoxGrey} from "../../../utils/common-styles";

export const ReportIssue = () => {

    const navigate = useNavigate();

    function clickHandler() {
        let url = "/static/report-an-issue";
        navigate(url);
    }
    
    return (
        <SidebarBoxGrey>
            <h6>Report an Issue</h6> 
            <p>In the case of an emergency, please call 999.</p>
            <p>&nbsp;</p>
            <p>For all other issues, please take a look at the article that we've prepared for you.</p>
            <div className="sidebar-button" style={{cursor: "pointer"}} onClick={clickHandler}>Find out more</div>    
        </SidebarBoxGrey>
    )
}

export default ReportIssue;
